import React, { FunctionComponent, ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import { Button, Divider, Text } from '@afterpaytouch/core'

export interface DetailRowProps {
  label: string
  value: ReactNode
  isEditable?: boolean
  onClick?: () => void
  testNameSpace?: string
}

const I18N_NAMESPACE = ['common', 'account']

export const DetailRow: FunctionComponent<DetailRowProps> = ({ label, value, isEditable = false, onClick = () => {}, testNameSpace }) => {
  const { t } = useTranslation(I18N_NAMESPACE)

  return (
    <div className='mb-8'>
      <div className='flex flex-row justify-between'>
        <div>
          <Text size='S' color='Gray40'>
            {label}
          </Text>
        </div>
        {isEditable && (
          <Button.Link size='Regular' onClick={onClick} aria-label='edit' testNameSpace={testNameSpace}>
            {t('account:tab:profile:body:cta')}
          </Button.Link>
        )}
      </div>
      <div className='my-2'>
        <Text size='M'>{value}</Text>
      </div>
      <Divider kind='Hairline' />
    </div>
  )
}
